export default __webpack_public_path__ + "static/media/star-outline.20f8fa29.svg";